import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { CONTACT } from '../data/mock';

const FOOTER_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Mission & Vision', to: '/mission-vision' },
  { label: 'Products', to: '/#products' },
  { label: 'SOC2 Questionnaires', to: '/services/soc2-questionnaires' },
  { label: 'Xccelera — RFP & Sales Enablement', to: '/services/rfp-sales-enablement' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#0A1220] text-slate-300 pt-16 pb-8 overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 left-1/4 w-[500px] h-[500px] rounded-full bg-[radial-gradient(closest-side,#FF7A2E,transparent_70%)] opacity-15" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size={38} tone="light" />
            <p className="mt-5 text-[14px] leading-[1.7] text-slate-400 max-w-sm">
              Authorized India distribution partner for RehabVeda R1 and
              Stroke Insightz. We also help Med-Tech startups win enterprise
              healthcare deals through SOC2 questionnaire response and RFP-driven sales enablement.
            </p>
            <div className="mt-5">
              <span className="text-[11px] uppercase tracking-widest font-semibold text-[#FFB27A]">
                Sales · Rentals · Training · Advisory
              </span>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="text-[12px] uppercase tracking-[0.2em] text-slate-500 font-semibold">Explore</div>
            <ul className="mt-5 space-y-3">
              {FOOTER_LINKS.map((l) =>
                l.to.includes('#') ? (
                  <li key={l.to}>
                    <a href={l.to} className="text-[14px] hover:text-[#FFB27A] transition-colors">{l.label}</a>
                  </li>
                ) : (
                  <li key={l.to}>
                    <Link to={l.to} className="text-[14px] hover:text-[#FFB27A] transition-colors">{l.label}</Link>
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-[12px] uppercase tracking-[0.2em] text-slate-500 font-semibold">Contact</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li className="text-slate-400">{CONTACT.addressIN}</li>
              {CONTACT.phones.map((p) => (
                <li key={p} className="text-slate-300">{p}</li>
              ))}
              <li>
                <a href={`mailto:${CONTACT.email}`} className="text-[#FFB27A] hover:underline">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="text-[12.5px] text-slate-500">
            © {new Date().getFullYear()} Mednosys Enterprises. All rights reserved.
          </div>
          <div className="text-[12.5px] text-slate-500">
            RehabVeda™ · Stroke Insightz™ are trademarks of their respective owners.
          </div>
        </div>
      </div>
    </footer>
  );
}
